import Api from '../../lib/Api'
import Consts from '../../lib/Consts'
import i18n from '../../lib/i18n'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    leastJewelToExchange: null,
    exchangeStep: null,
    isFetched: false,
    isFetching: false,
    isError: false
  },
  mutations: {
    fetchStatusInit (state) {
      state.isFetched = false
      state.isFetching = false
      state.isError = false
    },
    fetchStatusBegin (state) {
      state.isFetched = false
      state.isFetching = true
      state.isError = false
    },
    fetchStatusComplete (state) {
      state.isFetched = true
      state.isFetching = false
      state.isError = false
    },
    fetchStatusError (state) {
      state.isFetched = true
      state.isFetching = false
      state.isError = true
    },
    setValues (state, { leastJewelToExchange, exchangeStep }) {
      state.leastJewelToExchange = leastJewelToExchange
      state.exchangeStep = exchangeStep
    }
  },
  actions: {
    async fetch ({ commit, dispatch, rootState }) {
      commit('fetchStatusBegin')

      try {
        const serverConstants = await Api.getServerConstsnts()

        commit('fetchStatusComplete')
        commit('setValues', {
          leastJewelToExchange: serverConstants.leastRequiredJewelToExchange,
          exchangeStep: serverConstants.exchangeStep
        })
      } catch (e) {
        let errorMessage = 'Unknown error'
        if (e.response.data.error) {
          errorMessage = i18n.t('apiError', {
            message: e.response.data.error.message,
            code: e.response.data.error.error_code
          })
        }
        dispatch('displayAlert', { message: errorMessage }, { root: true })

        if (e.response.status === 401 && e.response.data.error.error_code === Consts.serverErrorCodes.CANNOT_AUTHENTICATE_USER) {
          commit('fetchStatusInit')
          dispatch('session/logout', null, { root: true })
          router.replace('/auth')
          return
        }
        console.error(e)
        commit('fetchStatusError')
      }
    },
    reset ({ commit }) {
      commit('fetchStatusInit')
      commit('setValues', { leastJewelToExchange: null, exchangeStep: null })
    }
  }
}
